export interface ICancel {
  cancel?: boolean;
}
